import React, { Component } from 'react';
import { CheckBox } from '../common/forms';
import { LabelWithArrow, Load } from '../common/basic';
import DropDown from '../common/dropDownOne';
import ReactDom from 'react-dom';
import axios from 'axios';
import { Radio } from 'react-bootstrap';
import dateHelper from '../../helpers/date';

var items = [
    { name: 1, id: 1 },
    { name: 2, id: 2 },
    { name: 3, id: 3 }
]
module.exports = class TrearmentBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            Order: this.props.data.Order,
            IsActive: this.props.data.isActive
        }

        this.chbOnChange = this.chbOnChange.bind(this);
        this.orderOnChange = this.orderOnChange.bind(this);
    }

    changeValues(order, isActive) {
        this.setState({
            Order: order,
            IsActive: isActive
        });

        this.chbIsActive.setChecked(isActive);
        this.Order.update(order);
    }

    chbOnChange(id, isActive) {
        this.setState({
            IsActive: isActive
        });

         this.props.updateDetails(isActive, this.state.Order, this.props.ID);
    }

    orderOnChange(val) {
        this.setState({
            Order: val
        });

        this.props.updateDetails(this.state.IsActive, val, this.props.ID);
    }

    render() {
        var checkboxID = this.props.ID + "IsChecked";
        var selectID = this.props.ID + "Order";
        var childrenDiv = (this.state.IsActive != true ? 'hidden' : '');
        return (
            <div className='treatmentBox'>
                <div className='treatmentBoxHeader'>
                    <div className='col-xs-4'>
                        <CheckBox id={checkboxID} checked={this.state.IsActive} ref={(chbIsActive) => { this.chbIsActive = chbIsActive; }} onChange={this.chbOnChange} />
                        <h4>{this.props.name}</h4>
                    </div>
                    <div className='col-xs-2'></div>
                    <div className='col-xs-6 order'>
                        <DropDown Data={items} Label="Order" ID={selectID} value={this.state.Order} ref={(Order) => { this.Order = Order; }} onChange={this.orderOnChange} />
                        <div className='reset'>Reset</div>
                    </div>

                </div>
                <div className={childrenDiv}>
                    {this.props.children}
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./modules/doctorAdvice/TrearmentBox.jsx